import * as React from 'react'
import { Button, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { SaveButton } from '@hyper/button'
import { FormInput } from '@hyper/forms'
import { useFormRequest } from '@components/hooks/use-api-request'
import { useNotificationHook } from '@hyper/use-notification-hook'
import { useForm } from 'react-hook-form'
import { BaseModalProps } from '@components/modals/types'
import { CustomReactSelectOption } from '@components/custom-react-select'
import { FormSelect } from '@hyper/forms/form-select'
import { ReceptionBookingDetails, ReceptionBookingGroup, ReservationBookingVoucher } from '@models/reception'
import { createSelectOption } from '@helpers/utils'
import { useAppDispatch } from '@store/index'
import { commonObjectPost } from '@store/actions/generic-actions'
import { updateReceptionBookingVoucherDetails } from '@store/slices/reservations-slice'
import { Form } from '@hyper/forms/form'

interface FormInputs {
  name: string
  group: CustomReactSelectOption
  price_brutto: string
}

interface Props extends BaseModalProps {
  booking: ReceptionBookingDetails
}

export const ReservationBistroVoucherAddModal: React.FC<Props> = ({ booking, toggleIsVisible }) => {
  const methods = useForm<FormInputs>()
  const { addSuccessMessage } = useNotificationHook()
  const dispatch = useAppDispatch()

  const { isLoading, action: onSubmit } = useFormRequest(async (payload: FormInputs) => {
    dispatch(
      updateReceptionBookingVoucherDetails(
        await commonObjectPost<ReservationBookingVoucher>(booking.urls.reservation_booking_vouchers, {
          ...payload,
          group: payload.group.value,
        }),
      ),
    )

    addSuccessMessage('Sukces', 'Voucher został dodany')
    toggleIsVisible()
  }, methods.setError)

  const groupOptions = React.useMemo(
    () => booking.groups.map((group: ReceptionBookingGroup) => createSelectOption(group.name, group.id)),
    [booking.groups],
  )

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ModalHeader toggle={toggleIsVisible}>Dodaj voucher</ModalHeader>
      <ModalBody>
        <Row>
          <FormInput colSize={6} label="Wartość" name="amount" type="number" />
          <FormSelect name="group" label="Grupa" options={groupOptions} formPlainProps={{ colSize: 6 }} />
          <FormInput label="Opis" name="description" type="textarea" />
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggleIsVisible}>
          Zamknij
        </Button>

        <SaveButton role="submit" className="btn btn-green" label="Zapisz" isSaving={isLoading} />
      </ModalFooter>
    </Form>
  )
}
